import { useTrackStorefrontImpression } from '@hooks/useTrackStorefrontImpression';
import { TextBody } from '@tkww/orion-web-ds';
import React from 'react';
import Styles from './PeaceOfMindHeader.scss';

export const PeaceOfMindHeader = () => {
	const trackingRef = useTrackStorefrontImpression('Peace of Mind');

	return (
		<div className={Styles.container} ref={trackingRef}>
			<TextBody color="info" size="xs" bold>
				The Knot Peace of Mind
			</TextBody>
		</div>
	);
};
